import { Button, Divider, makeStyles, Text, tokens } from '@fluentui/react-components';
import { AddFilled } from "@fluentui/react-icons";
import React from 'react';

const useStyles = makeStyles({
  container: {
    height: "42px",
    padding: `0 ${tokens.spacingHorizontalL}`,
    display: "flex",
    alignItems: "center",
    backgroundColor: tokens.colorNeutralBackground3,
  },
  text: {
    color: tokens.colorNeutralForeground1,
    padding: "0px 12px"
  }
});

export const AppValidationDataGridHeader: React.FC<{
  length: number;
  onNewValidationRequest: (value: boolean) => void;
}> = ({ length, onNewValidationRequest }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Button
        appearance='transparent'
        icon={<AddFilled />}
        onClick={() => onNewValidationRequest(true)}
      >{"New validation"}</Button>
      <Divider style={{ maxWidth: "12px" }} vertical />
      <Text className={classes.text}>{`${length} items`}</Text>
    </div>
  );
};
